const TellerAbi = [
  {
    type: "function",
    name: "accountant",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract AccountantWithRateProviders"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "addAsset",
    inputs: [
      { name: "asset", type: "address", internalType: "contract ERC20" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "addChain",
    inputs: [
      { name: "chainSelector", type: "uint32", internalType: "uint32" },
      { name: "allowMessagesFrom", type: "bool", internalType: "bool" },
      { name: "allowMessagesTo", type: "bool", internalType: "bool" },
      { name: "targetTeller", type: "address", internalType: "address" },
      { name: "messageGasLimit", type: "uint64", internalType: "uint64" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "allowMessagesFromChain",
    inputs: [
      { name: "chainSelector", type: "uint32", internalType: "uint32" },
      { name: "targetTeller", type: "address", internalType: "address" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "allowMessagesToChain",
    inputs: [
      { name: "chainSelector", type: "uint32", internalType: "uint32" },
      { name: "targetTeller", type: "address", internalType: "address" },
      { name: "messageGasLimit", type: "uint64", internalType: "uint64" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "authority",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract Authority" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "beforeTransfer",
    inputs: [{ name: "from", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "bridge",
    inputs: [
      { name: "shareAmount", type: "uint256", internalType: "uint256" },
      {
        name: "data",
        type: "tuple",
        internalType: "struct BridgeData",
        components: [
          { name: "chainSelector", type: "uint32", internalType: "uint32" },
          {
            name: "destinationChainReceiver",
            type: "address",
            internalType: "address"
          },
          {
            name: "bridgeFeeToken",
            type: "address",
            internalType: "contract ERC20"
          },
          { name: "messageGas", type: "uint64", internalType: "uint64" },
          { name: "data", type: "bytes", internalType: "bytes" }
        ]
      }
    ],
    outputs: [{ name: "messageId", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "bulkDeposit",
    inputs: [
      { name: "depositAsset", type: "address", internalType: "contract ERC20" },
      { name: "depositAmount", type: "uint256", internalType: "uint256" },
      { name: "minimumMint", type: "uint256", internalType: "uint256" },
      { name: "to", type: "address", internalType: "address" }
    ],
    outputs: [{ name: "shares", type: "uint256", internalType: "uint256" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "bulkWithdraw",
    inputs: [
      {
        name: "withdrawAsset",
        type: "address",
        internalType: "contract ERC20"
      },
      { name: "shareAmount", type: "uint256", internalType: "uint256" },
      { name: "minimumAssets", type: "uint256", internalType: "uint256" },
      { name: "to", type: "address", internalType: "address" }
    ],
    outputs: [{ name: "assetsOut", type: "uint256", internalType: "uint256" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "deposit",
    inputs: [
      { name: "depositAsset", type: "address", internalType: "contract ERC20" },
      { name: "depositAmount", type: "uint256", internalType: "uint256" },
      { name: "minimumMint", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "shares", type: "uint256", internalType: "uint256" }],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "depositAndBridge",
    inputs: [
      { name: "depositAsset", type: "address", internalType: "contract ERC20" },
      { name: "depositAmount", type: "uint256", internalType: "uint256" },
      { name: "minimumMint", type: "uint256", internalType: "uint256" },
      {
        name: "data",
        type: "tuple",
        internalType: "struct BridgeData",
        components: [
          { name: "chainSelector", type: "uint32", internalType: "uint32" },
          {
            name: "destinationChainReceiver",
            type: "address",
            internalType: "address"
          },
          {
            name: "bridgeFeeToken",
            type: "address",
            internalType: "contract ERC20"
          },
          { name: "messageGas", type: "uint64", internalType: "uint64" },
          { name: "data", type: "bytes", internalType: "bytes" }
        ]
      }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "depositNonce",
    inputs: [],
    outputs: [{ name: "", type: "uint96", internalType: "uint96" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "depositWithPermit",
    inputs: [
      { name: "depositAsset", type: "address", internalType: "contract ERC20" },
      { name: "depositAmount", type: "uint256", internalType: "uint256" },
      { name: "minimumMint", type: "uint256", internalType: "uint256" },
      { name: "deadline", type: "uint256", internalType: "uint256" },
      { name: "v", type: "uint8", internalType: "uint8" },
      { name: "r", type: "bytes32", internalType: "bytes32" },
      { name: "s", type: "bytes32", internalType: "bytes32" }
    ],
    outputs: [{ name: "shares", type: "uint256", internalType: "uint256" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "isPaused",
    inputs: [],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isSupported",
    inputs: [{ name: "", type: "address", internalType: "contract ERC20" }],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "nativeWrapper",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "contract WETH" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "pause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "previewFee",
    inputs: [
      { name: "shareAmount", type: "uint256", internalType: "uint256" },
      {
        name: "data",
        type: "tuple",
        internalType: "struct BridgeData",
        components: [
          { name: "chainSelector", type: "uint32", internalType: "uint32" },
          {
            name: "destinationChainReceiver",
            type: "address",
            internalType: "address"
          },
          {
            name: "bridgeFeeToken",
            type: "address",
            internalType: "contract ERC20"
          },
          { name: "messageGas", type: "uint64", internalType: "uint64" },
          { name: "data", type: "bytes", internalType: "bytes" }
        ]
      }
    ],
    outputs: [{ name: "fee", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "publicDepositHistory",
    inputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "refundDeposit",
    inputs: [
      { name: "nonce", type: "uint256", internalType: "uint256" },
      { name: "receiver", type: "address", internalType: "address" },
      { name: "depositAsset", type: "address", internalType: "address" },
      { name: "depositAmount", type: "uint256", internalType: "uint256" },
      { name: "shareAmount", type: "uint256", internalType: "uint256" },
      { name: "depositTimestamp", type: "uint256", internalType: "uint256" },
      {
        name: "shareLockUpPeriodAtTimeOfDeposit",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "removeAsset",
    inputs: [
      { name: "asset", type: "address", internalType: "contract ERC20" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "removeChain",
    inputs: [{ name: "chainSelector", type: "uint32", internalType: "uint32" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "selectorToChains",
    inputs: [{ name: "", type: "uint32", internalType: "uint32" }],
    outputs: [
      { name: "allowMessagesFrom", type: "bool", internalType: "bool" },
      { name: "allowMessagesTo", type: "bool", internalType: "bool" },
      { name: "targetTeller", type: "address", internalType: "address" },
      { name: "messageGasLimit", type: "uint64", internalType: "uint64" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "setAuthority",
    inputs: [
      {
        name: "newAuthority",
        type: "address",
        internalType: "contract Authority"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setChainGasLimit",
    inputs: [
      { name: "chainSelector", type: "uint32", internalType: "uint32" },
      { name: "messageGasLimit", type: "uint64", internalType: "uint64" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setShareLockPeriod",
    inputs: [
      { name: "_shareLockPeriod", type: "uint64", internalType: "uint64" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "shareLockPeriod",
    inputs: [],
    outputs: [{ name: "", type: "uint64", internalType: "uint64" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "shareUnlockTime",
    inputs: [{ name: "", type: "address", internalType: "address" }],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "stopMessagesFromChain",
    inputs: [{ name: "chainSelector", type: "uint32", internalType: "uint32" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "stopMessagesToChain",
    inputs: [{ name: "chainSelector", type: "uint32", internalType: "uint32" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [{ name: "newOwner", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unpause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "vault",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract BoringVault" }
    ],
    stateMutability: "view"
  },
  {
    type: "event",
    name: "AssetAdded",
    inputs: [
      {
        name: "asset",
        type: "address",
        indexed: true,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "AssetRemoved",
    inputs: [
      {
        name: "asset",
        type: "address",
        indexed: true,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "AuthorityUpdated",
    inputs: [
      { name: "user", type: "address", indexed: true, internalType: "address" },
      {
        name: "newAuthority",
        type: "address",
        indexed: true,
        internalType: "contract Authority"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "BulkDeposit",
    inputs: [
      {
        name: "asset",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "depositAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "BulkWithdraw",
    inputs: [
      {
        name: "asset",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "shareAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "ChainAdded",
    inputs: [
      {
        name: "chainSelector",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      {
        name: "allowMessagesFrom",
        type: "bool",
        indexed: false,
        internalType: "bool"
      },
      {
        name: "allowMessagesTo",
        type: "bool",
        indexed: false,
        internalType: "bool"
      },
      {
        name: "targetTeller",
        type: "address",
        indexed: false,
        internalType: "address"
      },
      {
        name: "messageGasLimit",
        type: "uint64",
        indexed: false,
        internalType: "uint64"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "ChainAllowMessagesFrom",
    inputs: [
      {
        name: "chainSelector",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      {
        name: "targetTeller",
        type: "address",
        indexed: false,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "ChainAllowMessagesTo",
    inputs: [
      {
        name: "chainSelector",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      {
        name: "targetTeller",
        type: "address",
        indexed: false,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "ChainRemoved",
    inputs: [
      {
        name: "chainSelector",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "ChainSetGasLimit",
    inputs: [
      {
        name: "chainSelector",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      {
        name: "messageGasLimit",
        type: "uint64",
        indexed: false,
        internalType: "uint64"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "ChainStopMessagesFrom",
    inputs: [
      {
        name: "chainSelector",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "ChainStopMessagesTo",
    inputs: [
      {
        name: "chainSelector",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "Deposit",
    inputs: [
      {
        name: "nonce",
        type: "uint256",
        indexed: true,
        internalType: "uint256"
      },
      {
        name: "receiver",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "depositAsset",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "depositAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      {
        name: "shareAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      {
        name: "depositTimestamp",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      {
        name: "shareLockPeriodAtTimeOfDeposit",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "DepositRefunded",
    inputs: [
      {
        name: "nonce",
        type: "uint256",
        indexed: true,
        internalType: "uint256"
      },
      {
        name: "depositHash",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32"
      },
      { name: "user", type: "address", indexed: true, internalType: "address" }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "MessageReceived",
    inputs: [
      {
        name: "messageId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32"
      },
      {
        name: "shareAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      { name: "to", type: "address", indexed: false, internalType: "address" }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "MessageSent",
    inputs: [
      {
        name: "messageId",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32"
      },
      {
        name: "shareAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      { name: "to", type: "address", indexed: false, internalType: "address" }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      { name: "user", type: "address", indexed: true, internalType: "address" },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  { type: "event", name: "Paused", inputs: [], anonymous: false },
  { type: "event", name: "Unpaused", inputs: [], anonymous: false },
  { type: "error", name: "CrossChainTellerBase_GasLimitExceeded", inputs: [] },
  {
    type: "error",
    name: "CrossChainTellerBase_MessagesNotAllowedTo",
    inputs: [
      { name: "chainSelector", type: "uint256", internalType: "uint256" }
    ]
  },
  {
    type: "error",
    name: "CrossChainTellerBase_ZeroMessageGasLimit",
    inputs: []
  },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__AssetNotSupported",
    inputs: []
  },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__BadDepositHash",
    inputs: []
  },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__DualDeposit",
    inputs: []
  },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__MinimumAssetsNotMet",
    inputs: []
  },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__MinimumMintNotMet",
    inputs: []
  },
  { type: "error", name: "TellerWithMultiAssetSupport__Paused", inputs: [] },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__PermitFailedAndAllowanceTooLow",
    inputs: []
  },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__ShareLockPeriodTooLong",
    inputs: []
  },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__SharesAreLocked",
    inputs: []
  },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__SharesAreUnLocked",
    inputs: []
  },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__ZeroAssets",
    inputs: []
  },
  {
    type: "error",
    name: "TellerWithMultiAssetSupport__ZeroShares",
    inputs: []
  }
];
export {
  TellerAbi
};
//# sourceMappingURL=teller-abi.mjs.map